import { ApplicationType } from '@upstart/harmony/lib/legos/constants';
import BackendService from './BackendService';
import CarService from './CarService';

export default class DealService {
  static getShowroomList(startDate, endDate) {
    const params = {
      since: startDate,
      until: endDate,
    };
    return BackendService.get('/deals/showroomList', { params });
  }

  static getOnlineList(startDate, endDate) {
    const params = {
      since: startDate,
      until: endDate,
    };
    return BackendService.get('/deals/onlineList', { params });
  }

  static exportDeals(searchParams) {
    const params = {
      search: searchParams,
      type: 'blob',
    };
    return BackendService.get('/deals/csv', { params });
  }

  static getAllDeals(page, perPage, searchParams, sortParams) {
    const params = {
      page,
      perPage,
      search: searchParams,
    };
    if (sortParams && sortParams.name) {
      params.sortName = sortParams.name;
    }
    if (sortParams && sortParams.order) {
      params.sortOrder = sortParams.order;
    }
    return BackendService.get('/deals/all', { params });
  }

  static getDeal(dealId) {
    return BackendService.get(`/deals/${dealId}`);
  }

  static getUser(userId) {
    return BackendService.get(`/users/${userId}`);
  }

  static getCar(carId) {
    return CarService.getCar(carId);
  }

  /**
   *
   * @param dealId id of the deal
   * @param body object containing deal values
   * @param sendNotification boolean flag to trigger notification sending logic
   * @param forwardLead boolean flag to trigger if lead forwarding should occur in update deal.
   * @return {Promise<Blob|any|undefined>}
   */
  static updateDeal({
    dealId,
    body,
    sendNotification = true,
    forwardLead = true,
  }) {
    const params = {
      useSessionUserId: false,
      sendNotification,
      forwardLead,
    };
    return BackendService.put(`/deals/${dealId}`, { params, body });
  }

  static updateRequestStatus(dealId, type, status) {
    return BackendService.put(`/deals/${dealId}/requestStatus`, {
      body: {
        type,
        status,
      },
    });
  }

  static createDeal(body) {
    return BackendService.post('/deals', { body });
  }

  static forwardDealToFNI(dealId, body) {
    return BackendService.post(`/deals/forwardDealToFNI/${dealId}`, { body });
  }

  static createOnlineDeal(dealerId, body) {
    return BackendService.postWithoutToken('/deals', dealerId, { body });
  }

  static createCRMLead(dealId) {
    return BackendService.post(`/deals/create/dealer/${dealId}`);
  }

  /**
   * Update lead through crm:forwardLead queue.
   * @param dealId
   * @return {Promise<Blob|any|undefined>}
   */
  static forwardCRMLead({ params, body }) {
    const { id } = body;
    return BackendService.post(`/deals/forward/dealer/${id}`, {
      params,
      body,
    });
  }

  static pushVehicle(dealId) {
    return BackendService.post(`/deals/push/vehicle/${dealId}`);
  }

  static getAppraisedValue(dealId, tradeIn) {
    return BackendService.post(`/deals/${dealId}/appraisedValue`, {
      body: { tradeIn },
    });
  }

  static printCreditApplication(dealId) {
    return BackendService.post(`/deals/${dealId}/print`, {
      body: {
        id: dealId,
        name: ApplicationType.CREDIT_APPLICATION,
        applicationType: ApplicationType.CREDIT_APPLICATION,
      },
    });
  }
}
